import { createAction,props } from '@ngrx/store';
import { IWalletTeen } from '../interfaces/parent.interfaces';
import { IMemberFullData } from '../interfaces/parent.responses';

export const PARENT_ACTION_ITEM = '[Parent]' as const

export const setTeens = createAction(`${PARENT_ACTION_ITEM} setTeens`, props<{ teens:IMemberFullData[] }>());
export const setTeenWallets = createAction(`${PARENT_ACTION_ITEM} setTeenWallets`, props<{ wallets:IWalletTeen[] }>());
export const setIsGettingWallets = createAction(`${PARENT_ACTION_ITEM} setIsGettingWallets`,  props<{ isGetting:boolean }>())
